import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=f4a67240&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=f4a67240&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a67240",
  null
  
)

export default component.exports